import React, { useState, useEffect } from "react";

export const Header = (props) => {
  const images = ["img/intro-bg.jpg", "img/intro-bg2.jpg"];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const nextImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setFade(true);
    }, 300); // Duration of the fade-out transition
  };

  const prevImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      setFade(true);
    }, 300); // Duration of the fade-out transition
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="intro-text">
                <button className="btn-round left" onClick={prevImage}>
                  <i className="fa fa-arrow-left"></i>
                </button>
                <img
                  src={images[currentImageIndex]}
                  alt=""
                  className={`smooth-image ${fade ? "fade-in" : "fade-out"}`}
                />
                <button className="btn-round right" onClick={nextImage}>
                  <i className="fa fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};